// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Fycu","errorLogs":"styles_errorLogs__23E6K"};